<template>
  <div>
    <dialog-manager />
    <snackbar-manager />
  </div>
</template>
<script setup>
import DialogManager from "@/app-services/DialogManager.vue";
import SnackbarManager from "@/app-services/SnackbarManager.vue";
import { useOutboundCallObserver } from "@/app-services/OutboundCallObserver.mjs";
import { useThemeManager } from "@/app-services/ThemeManager.mjs";
import { onMounted } from "vue";
import {
  useActionCable,
  useAuthEvents,
  addKeepAliveChannel
} from "@/util/socket-helper-servicev2";
import { useRouter } from "vue-router";

const router = useRouter();

useOutboundCallObserver();
useThemeManager();

onMounted(() => {
  useActionCable();
  addKeepAliveChannel(() => useAuthEvents(router), "auth-events");
});
</script>
